export var CloudPlatform;
(function (CloudPlatform) {
    /**
     * cloudfront
     */
    CloudPlatform["CloudFront"] = "CloudFront";
    /**
     * 阿里云
     */
    CloudPlatform["AlibabaCloud"] = "AlibabaCloud";
})(CloudPlatform || (CloudPlatform = {}));
